import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button as AntdButton, Flex, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../../../components/common/Icon';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardFooter, LeftPanelCardHead, LeftPanelContainer, } from '../editor.style';
import EscalatorForm from '../components/Connections';
const initialValues = {
    name: '',
    iconFromDefaultList: '',
    sortOrder: 1,
    color: null,
    externalId: '',
    imageUrl: [],
};
const ConnectionsPanel = ({ connectionData, siteId, isOpen, onBack, form, setSelectedNodeIndex, updateStateData, }) => {
    const dispatch = useDispatch();
    //   const [form] = Form.useForm();
    const [container, setContainer] = useState(null);
    //   const [editCategory, setEditCategory] = useState<boolean | { [key: string]: any }>(false);
    //   useEffect(() => {
    //     if (categoryData) {
    //       form.setFieldsValue(categoryData);
    //       setEditCategory(categoryData);
    //     } else {
    //       form.setFieldsValue(initialValues);
    //       setEditCategory(false);
    //     }
    //   }, [categoryData]);
    const { createCategory: { loading: creatingCategory }, updateCategory: { loading: updatingCategory }, deleteCategory: { loading: deletingCategory }, } = useSelector((state) => state?.editor);
    const categoryIcons = useSelector((state) => state?.editor?.categoryIcons?.response);
    return (_jsx(_Fragment, { children: _jsx(LeftPanel, { isOpen: isOpen, style: {
                width: '340px',
            }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsx(LeftPanelCardHead, { children: _jsxs(Flex, { align: "center", children: [_jsx(AntdButton, { style: { marginLeft: '-8px' }, color: "default", variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }), onClick: () => {
                                            onBack();
                                        } }), _jsx("h3", { children: !!connectionData ? 'Edit Connection' : 'Create New Connection' })] }) }), _jsx(LeftPanelCardBody, { style: { padding: '0 16px 16px' }, ref: setContainer, children: _jsx(EscalatorForm, { setSelelectNodeIndex: setSelectedNodeIndex, updateStateData: updateStateData, formConnection: form }) }), _jsxs(LeftPanelCardFooter, { children: [_jsx(Button, { onClick: () => {
                                        //   setSelectNode(false);
                                        //   setSeletedSidebar('connections');
                                        //   setEditConnection(null);
                                        onBack();
                                        form.resetFields();
                                    }, color: "danger", variant: "filled", children: 'Cancel' }), _jsx(Button, { loading: creatingCategory || updatingCategory, onClick: () => {
                                        form
                                            .validateFields()
                                            .then(() => {
                                            form.submit();
                                            onBack();
                                            //   setEditConnection(null);
                                            //   setSeletedSidebar('connections');
                                        })
                                            .catch((error) => {
                                        });
                                    }, color: "primary", variant: "solid", children: "Save" })] })] }) }) }) }));
};
export default React.memo(ConnectionsPanel);
